import { IContact } from "../../../contact/~store/models/Contact";

export const ContactTagValue = (contact: IContact) => {
    return contact.firstName || contact.lastName || contact.chatName || contact.phone;
}